import { useQuery } from '@tanstack/react-query';
import { SessionSummaryDto } from '@repo/shared/dtos/devices/SessionDto';
import { myInsightsQueryKeys } from './queryKeys';
import { ANALYTICS_SESSIONS_BASE_URL, CACHE_DURATION_MS } from '../config/constants';

async function fetchInsightsSummary(): Promise<SessionSummaryDto> {
  const response = await fetch(ANALYTICS_SESSIONS_BASE_URL);
  if (!response.ok) {
    throw new Error('Failed to fetch session summary');
  }
  return response.json();
}

export const useInsightsSummary = () =>
  useQuery({
    queryKey: myInsightsQueryKeys.summary(),
    queryFn: fetchInsightsSummary,
    staleTime: CACHE_DURATION_MS,
    structuralSharing: true,
  });
